export enum DateFormat {
  ABBREV_MONTH_DAY = 'MMM d',
  DATEONLY_KEBAB = 'yyyy-MM-dd',
  FULL_DATE = 'MMMM dd, yyyy',
  FULL_DATE_ABBREV_DAY = 'MMMM d, yyyy',
  FULL_DATE_ABBREV_MONTH = 'MMM dd, yyyy',
  FULL_SLASH_DATE_US = 'MM/dd/yyyy',
}

export enum TimeFormat {
  CLOCK_12 = 'h:mm a',
}

export const ONE_SECOND_MS = 1000;
export const TEN_SECONDS_MS = 10 * ONE_SECOND_MS;

export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;

export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
